import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';
import RouterConfig from './router/router';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<RouterConfig />);
